import { render, staticRenderFns } from "./ButtonSendActivationEmail.vue?vue&type=template&id=3f7d7ade&"
import script from "./ButtonSendActivationEmail.vue?vue&type=script&lang=js&"
export * from "./ButtonSendActivationEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports